module.exports = "/_next/static/images/286e7692df14d55721b078210815eda2-card-hugh.svg";